import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import List from "devextreme-react/list";
import {
  clinithinkLogo,
  clinithinkLogoCollapse,
  collapseButtonSvg,
  collapseLogo,
  expandedLogo,
  logOutSvg,
  OrgIcon,
  ResourceIcon,
} from "../../Assets/SVGs/sideNavSVGs";
import { useUser } from "../../contexts/UserContext";
import { resRoles } from "../../Constants/constants";

const handleLogout = (instance) => {
  instance.logoutRedirect().catch((e) => {
    console.error(e);
  });
};

const navItems = [
  { id: 1, text: "Organizations", icon: OrgIcon, path: "Organization" },
  {
    id: 2,
    text: "Resources",
    icon: ResourceIcon,
    path: "Resource",
  },
];

const SidePanelContent = ({ isDrawerOpen, setIsDrawerOpen }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const { userRoles } = useUser();
  const { instance } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();

  const hasResourcesAccess =
    userRoles?.includes(resRoles.resMangerRole) ||
    userRoles?.includes(resRoles.resReadRole) ||
    userRoles?.includes(resRoles.resWriteRole);

  const handleNavItemClick = (e) => {
    navigate(e?.itemData?.path);
  };

  const toggleSidePanel = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    if (location.pathname === "/Organization") {
      setSelectedIndex(0);
    } else if (location.pathname === "/Resource") {
      setSelectedIndex(1);
    }
  }, [location.pathname]);

  const navItem = ({ id, icon, text }) => (
    <div className={`sidepanel-item sidepanel-item--${id}`}>
      <span className="sidepanel-item-icon" title={text}>
        {icon}
      </span>
      <span className="sidepanel-item-name">{text}</span>
    </div>
  );

  const renderNavItem = (item) =>
    item.text === "Resources" ? hasResourcesAccess && navItem(item) : navItem(item);

  return (
    <div className={`sidepanel-content sidepanel-${isDrawerOpen ? "open" : "close"}`}>
      <div className="panel-content">
        <div className="panel-section-top">
          <div className="panel-header">
            <div
              id="sidepanelcontent-site-logo"
              className={
                isDrawerOpen ? "partner-portal-logo-expanded" : "partner-portal-logo"
              }
            >
              {isDrawerOpen ? expandedLogo : collapseLogo}
            </div>
            <div id="sidepanelcontent-toggle" className="sidepanel-toggle">
              <div
                className={
                  isDrawerOpen ? "sidepanel-toggle-btn-expanded" : "sidepanel-toggle-btn"
                }
                role="button"
                tabIndex={0}
                onClick={toggleSidePanel}
                onKeyDown={toggleSidePanel}
              >
                {collapseButtonSvg}
              </div>
            </div>
          </div>
          <div className="panel-tabs-wrapper">
            <List
              items={navItems}
              selectionMode="single"
              selectedIndex={selectedIndex}
              onItemClick={handleNavItemClick}
              itemRender={renderNavItem}
            />
          </div>
        </div>
        <div className="panel-section-bottom">
          <div className="panel-footer">
            <div className="panel-logout">
              <div
                className="sidepanel-logout-btn"
                onClick={() => handleLogout(instance)}
                onKeyDown={() => handleLogout(instance)}
                tabIndex={0}
                role="button"
                aria-label="Logout"
              >
                <span className="logout-icon">{logOutSvg}</span>
                {isDrawerOpen && <span className="logout-label">Logout</span>}
              </div>
              <div className="sidepanel-clinithink-logo">
                {isDrawerOpen ? clinithinkLogo : clinithinkLogoCollapse}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SidePanelContent.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  setIsDrawerOpen: PropTypes.func.isRequired,
};

export default SidePanelContent;
